import "./TravelGuidesDe.module.css";
import Header from "@/reusable_sections/Header";
import TravelGuides from "./sections/TravelGuides";
import Footer from "@/reusable_sections/Footer";
export default function TravelGuidesDePage() {
  return <div>
      <Header />
      <TravelGuides />
      <Footer />
    </div>;
}